import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private apiUrl: string;

  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    }
  }

  getCollections(filters: any) {
    return this.http.get(this.apiUrl + '/reports/collections', {
      params: filters, ...this.getAuthHeaders()
    });
  }

  exportCollections(filters: any) {
    return this.http.get(
      `${this.apiUrl}/reports/collections/export`,
      {
        params: filters,
        responseType: 'blob',
        ...this.getAuthHeaders()
      }
    );
  }

  getDailyPatientDetails(payload: any) {
    return this.http.get(this.apiUrl + '/reports/collections/details', {
      params: payload, ...this.getAuthHeaders()
    });
  }

  exportDailyPatientDetails(filters: any) {
    return this.http.get(
      `${this.apiUrl}/reports/collections/details/export`,
      {
        params: filters,
        responseType: 'blob',
        ...this.getAuthHeaders()
      }
    );
  }
}
